//frontend/src/components/route/ProtectedRoute.js
// frontend/src/components/route/ProtectedRoute.js
// ProtectedRoute.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from '../layouts/Loader';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useSelector(state => state.authState);
    const { shippingInfo } = useSelector(state => state.cartState);
    const isGuestCheckout = localStorage.getItem('isGuestCheckout') === 'true';

    // Show loader while checking authentication
    if (loading) {
        return <Loader/>;
    }

    // For shipping page, always show if authenticated
    if (window.location.pathname === '/shipping') {
        if (!isAuthenticated && !isGuestCheckout) {
            return <Navigate to="/login" />;
        }
        return children;
    }

    // For other protected routes
    if (!isAuthenticated && !isGuestCheckout) {
        return <Navigate to="/login" />;
    }

    // Special handling for order confirmation
    if (window.location.pathname === '/order/confirm') {
        if (!shippingInfo || !Object.keys(shippingInfo).length) {
            return <Navigate to={isAuthenticated ? "/shipping" : "/guest-checkout"} />;
        }
    }

    return children;
}
